/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  SEARCH_COUNTERS_REQUEST,
  SEARCH_COUNTERS_SUCCESS,
  SEARCH_COUNTERS_FAILURE,
  ADD_COUNTER_REQUEST,
  ADD_COUNTER_SUCCESS,
  ADD_COUNTER_FAILURE,
  UPDATE_COUNTER_REQUEST,
  UPDATE_COUNTER_SUCCESS,
  UPDATE_COUNTER_FAILURE
} from "src/actions/counterActions";

const initialState = {
  counters: [],
  counter: {},
  total: 0,
  loading: false
};

const counterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_COUNTERS_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case SEARCH_COUNTERS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.counters = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case SEARCH_COUNTERS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case ADD_COUNTER_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_COUNTER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.counters = draft.counters.concat(response);
        draft.loading = false;
      });
    }

    case ADD_COUNTER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_COUNTER_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_COUNTER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        const {counters} = draft;
        const filteredCounters = counters.filter((counter) => counter.id != response.id);
        draft.counters = filteredCounters;
        draft.loading = false;
      });
    }

    case UPDATE_COUNTER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default counterReducer;
